module.exports = __webpack_public_path__ + "img/NearPointofConvergence_Icon_200x200_Black.61164575.png";